import axios from 'axios';

export class CaptchaModel {
    captchaUrl = '/webapi/auth/regcaptcha';

    currentCode = this.generateCode();

    refresh() {
      return axios.get(`${this.captchaUrl}?refresh=1`).then(() => {
        const code = this.generateCode();
        const url = `${this.captchaUrl}?v=${code}`;
        return this.loadImage(url).then(() => {
          this.currentCode = code;
          return code;
        });
      });
    }

    generateCode() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    get imageSource() {
      return `${this.captchaUrl}?v=${this.currentCode}`;
    }

    loadImage(url: string) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', (e) => resolve(img));
        img.addEventListener('error', () => {
          reject(new Error(`Failed to load image's URL: ${url}`));
        });
        img.src = url;
      });
    }
}
